import { useConfigStore } from '@/store/config'
import { pinia } from '@/store/pinia'

export function playSound(name: 'payment' | 'cancel' | 'notification' | 'alert') {
  const config = useConfigStore(pinia)
  if (!config.mute) {
    const sound = new Audio(`${name}.mp3`)
    sound.play().catch(() => {
      // iOS requires user interaction to play sounds
    })
  }
}
